<template>
    <BaseDialog v-model:open="open" :title="title" width="narrow" @close="onCancel">
        <p v-if="text" class="body text-ink-muted">{{ text }}</p>
        <slot></slot>
        <template #footer>
            <BaseButton theme="tertiary" data-testid="cancel-button" @click="onCancel">{{ cancelLabel ?? t("reflections.submitConfirm.continueEditing") }}</BaseButton>
            <BaseButton theme="primary" :disabled="confirmDisabled" data-testid="confirm-button" @click="onConfirm">
                {{ confirmLabel ?? t("components.assessment.submitConfirmLabel") }}
            </BaseButton>
        </template>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import { useI18n } from "vue-i18n";

interface Props {
    title: string;
    text?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmDisabled?: boolean;
}

const { t } = useI18n();

withDefaults(defineProps<Props>(), {
    text: "",
    confirmDisabled: false,
});

const emit = defineEmits<{ confirm: []; cancel: [] }>();

const open = defineModel<boolean>("open", { default: false });

function onConfirm() {
    emit("confirm");
}

function onCancel() {
    open.value = false;
    emit("cancel");
}
</script>
